
function addressTabs() {    
    $('.map-tabs__controls li').click(function(){
        var tab_id = $(this).attr('data-map-tab');
        $('.map-tabs__controls li').removeClass('active');
        $('.map-tabs__controls li').removeClass('bg-ivory');
        $('.map-tabs__controls li').removeClass('text-blue-dark');
        $('.map-tabs__controls li').addClass('bg-blue-dark');
        $('.map-tabs__controls li').addClass('text-ivory');
        $('.map-tabs__content').removeClass('active');
        $('.map-tabs__content').removeClass('block');
        $('.map-tabs__content').addClass('hidden');
        $('.map-tabs__directions').removeClass('active');
        $('.map-tabs__directions').removeClass('block');
        $('.map-tabs__directions').addClass('hidden');

        $(this).addClass('active');
        $(this).removeClass('bg-blue-dark');
        $(this).removeClass('text-ivory');
        $(this).addClass('text-blue-dark');
        $(this).addClass('bg-ivory');
        $("#"+tab_id).addClass('active');
        $("#"+tab_id).addClass('block');
        $("#"+tab_id).removeClass('hidden');
        $("[data-map-directions=directions-"+tab_id+"]").addClass('active');
        $("[data-map-directions=directions-"+tab_id+"]").addClass('block');
        $("[data-map-directions=directions-"+tab_id+"]").removeClass('hidden');

        $(window).trigger('resize');
        // $('.map-slider').slick('refresh');
        //$('.timeline-slider').slick('refresh');
        // initialiseTimelineSlider();
    });
}

function getDirections() {
    var directionsButtons = document.querySelectorAll('[data-get-directions]');
    
    directionsButtons.forEach((button) => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            let parentEl = button.parentNode;
            
            let postcode = parentEl.querySelector('#postcode').value;        
            let directionLink = button.getAttribute('data-direction-link');
            let url = 'https://www.google.com/maps/dir/' + postcode + '/'+ directionLink +',8z/';
		    window.open(url, '_blank').focus();
		    console.info(url);
        })
    })    
}

function map() {
    addressTabs();
    getDirections()
}

export default map;